import { render } from "./ChallengeResultsStatCorrectness.vue?vue&type=template&id=f056b982&scoped=true"
import script from "./ChallengeResultsStatCorrectness.vue?vue&type=script&lang=js"
export * from "./ChallengeResultsStatCorrectness.vue?vue&type=script&lang=js"

import "@/css/components/challenge-results-stat-correctness.css?vue&type=style&index=0&id=f056b982&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f056b982"]])

export default __exports__